export const CLICK_DELAY_MS = 300;
